interface DataRowProps {
  label?: string;
  labelNode?: React.ReactNode;
  value: React.ReactNode;
  variant?: 'primary' | 'secondary'; // primary is the default where background is white, secondary is where background is gray
}

const DataRow: React.FC<DataRowProps> = ({
  label,
  labelNode,
  value,
  variant = 'primary',
}) => {
  return (
    <div
      className={`flex flex-row p-2xl rounded-2xl w-full justify-between items-center ${
        // data row color is inverse of the card background color
        variant === 'secondary' ? 'bg-bg-primary' : 'bg-bg-secondary'
      }`}
    >
      {labelNode || (
        <div className="w-full text-text-secondary txt-small-medium">
          {label}
        </div>
      )}
      <div className="w-full text-right text-text-primary txt-medium-medium">
        {value || '-'}
      </div>
    </div>
  );
};

export { DataRow };
